import { createContext } from "react";

export const OfertasContext = createContext()